define('home/views/ProfilePostCollectionView',[
    'backbone-marionette',

    'home/views/ProfilePostView',
], function (
    Marionette,

    ProfilePostView
) {
    'use strict';

    /**
     * A view that shows a collection of posts that are all by the same author.
     * If the post is a reply, it shows the parent comment's author in the header.
     */
    var ProfilePostCollectionView = Marionette.CollectionView.extend({
        getItemView: function () {
            return ProfilePostView;
        },

        itemViewOptions: function (activity) {
            var model = activity.object;

            var itemOptions = {
                model: model,
            };

            if (activity.get('verb') === 'reply')
                itemOptions.replyAuthor = activity.target.author;

            return itemOptions;
        },
    });

    return ProfilePostCollectionView;
});

